export class ScoreUtis {
    /**
     * Reads the score from the route. This is fetched from the data in the last stop in the route.
     * If no last stop is found, the `CalculateScore` is used instead
     * @param route
     * @param movementCount: if given, every aspect will be multiplied with this number.
     * @constructor
     */
    static ReadScore(route, movementCount = 1) {
        const lastStop = route.features[route.features.length - 1];
        if (lastStop === undefined) {
            return ScoreUtis.CalculateScore(route, movementCount);
        }
        const comfort = Number(lastStop.properties["_score_comfort"] ?? "0");
        const safety = Number(lastStop.properties["_score_safety"] ?? "0");
        const distance = Number(lastStop.properties["distance"] ?? "0");
        const time = Number(lastStop.properties["time"] ?? "0");
        return ({
            comfort: comfort * movementCount,
            safety: safety * movementCount,
            distance: distance * movementCount,
            time: time * movementCount
        });
    }
    /**
     * Calculates the score, based on the length and score of every segment
     * @param route
     * @param movementCount
     * @constructor
     */
    static CalculateScore(route, movementCount = 1) {
        let comfort = 0;
        let safety = 0;
        let distance = 0;
        let time = 0;
        for (const feature of route.features) {
            if (feature.geometry.type !== "LineString") {
                // Ignore start- and end-positions
                continue;
            }
            const properties = feature.properties;
            const d = parseFloat(properties["distance"]);
            const t = parseFloat(properties["time"]);
            if (properties["_priority_comfort"]) {
                comfort += parseFloat(properties["_priority_comfort"] ?? 0) * d;
                safety += parseFloat(properties["_priority_safety"] ?? 0) * d;
            }
            time += t;
            distance += d;
        }
        return {
            comfort: comfort * movementCount,
            safety: safety * movementCount,
            distance: distance * movementCount,
            time: time * movementCount
        };
    }
    static Calculate(routes) {
        const totalScore = {
            comfort: 0,
            safety: 0,
            distance: 0,
            time: 0,
        };
        if (routes.length == 0) {
            return totalScore;
        }
        let cycleDistance = 0;
        for (const route of routes) {
            const routeScore = ScoreUtis.ReadScore(route);
            totalScore.time += routeScore.time;
            totalScore.distance += routeScore.distance;
            if (routeScore.comfort > 0) {
                totalScore.comfort += routeScore.comfort;
                totalScore.safety += routeScore.safety;
                cycleDistance += routeScore.distance;
            }
        }
        totalScore.comfort = totalScore.comfort / cycleDistance;
        totalScore.safety = totalScore.safety / cycleDistance;
        return totalScore;
    }
}
